import { action } from "@ember/object"
import Component from "@glimmer/component"

interface Options {
  isOff: boolean
  shouldRemoveHistory: boolean
}

interface Sig {
  Args: {
    options: Options
    accept: (shouldRemoveHistory: boolean) => void
    decline: () => void
  }
}

export default class ConfirmDeleteAllLessonsOnDay extends Component<Sig> {
  @action
  onKeydown(event: KeyboardEvent) {
    if (event.key === "Enter") {
      event.stopPropagation()
      this.args.accept(this.args.options.shouldRemoveHistory)
    }
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    "Dialogs::ConfirmDeleteAllLessonsOnDay": ConfirmDeleteAllLessonsOnDay
  }
}
